import { HttpContextToken } from '@angular/common/http';

export const HTTP_CONTEXT_ENDPOINT = new HttpContextToken<string | null>(() => null);
